module.exports = __webpack_public_path__ + "static/img/咨询医生@3x.6742af0.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dhry/assets/navs/咨询医生@3x.png
// module id = 312
// module chunks = 379 380